import EditIOAttribute from './EditIOAttribute'

export default EditIOAttribute
